import styled from "@emotion/styled";

export const Box = styled.div`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;
